'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dCategory from "./mealorama.-Category.js";
var $p;
/** @constructor */
function $c_Lmealorama_Category$() {
}
export { $c_Lmealorama_Category$ as $c_Lmealorama_Category$ };
$p = $c_Lmealorama_Category$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Category$;
/** @constructor */
function $h_Lmealorama_Category$() {
}
export { $h_Lmealorama_Category$ as $h_Lmealorama_Category$ };
$h_Lmealorama_Category$.prototype = $p;
$p.m = (function() {
  return "Category";
});
$p.aS9 = (function(x$0) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  return new $j_mealorama$002e$002dCategory.$c_Lmealorama_Category($x_1.l, $x_1.h, x$0.g(1), (!(!x$0.g(2))), x$0.g(3));
});
var $d_Lmealorama_Category$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Category$, "mealorama.Category$", ({
  FD: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_Category$ as $d_Lmealorama_Category$ };
var $n_Lmealorama_Category$;
function $m_Lmealorama_Category$() {
  if ((!$n_Lmealorama_Category$)) {
    $n_Lmealorama_Category$ = new $c_Lmealorama_Category$();
  }
  return $n_Lmealorama_Category$;
}
export { $m_Lmealorama_Category$ as $m_Lmealorama_Category$ };
//# sourceMappingURL=mealorama.-Category$.js.map
